export default __webpack_public_path__ + "static/media/ic_history-impact.f10493df.svg";